<template>
  <div class="img-show-wrapper">
    <div class="img-show-page" :style="combinedStyle" @mousedown="startDrag" @click="toggleZoom">
      <div class="content">
        <div v-if="showImage && imageSrc" class="image-container">
          <img
              :src="imageSrc"
              class="image"
              alt=""
              @dragstart.prevent
          />
        </div>

        <div v-else class="placeholder">暂无图片</div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ImgShow',
  data() {
    return {
      srcFromQuery: '',
      bgFromQuery: '',
      bgImgFromQuery: '',
      showImage: true,
      scale: 1, // 缩放比例
      translateX: 0, // X轴偏移
      translateY: 0, // Y轴偏移
      isDragging: false, // 是否正在拖拽
      startX: 0, // 拖拽起始X坐标
      startY: 0, // 拖拽起始Y坐标
      minScale: 0.5, // 最小缩放比例
      maxScale: 5, // 最大缩放比例
      isZoomed: false, // 是否处于放大状态
      dragStartTime: 0, // 拖拽开始时间
      hasDragged: false // 是否发生了拖拽
    }
  },


  computed: {
    imageSrc() {
      return this.srcFromQuery || ''
    },
    pageStyle() {
      const style = {}
      const bgColor = this.resolveBgColor(this.bgFromQuery)
      if (bgColor) style.background = bgColor
      if (this.bgImgFromQuery) {
        style.backgroundImage = `url('${this.bgImgFromQuery}')`
        style.backgroundSize = 'cover'
        style.backgroundPosition = 'center center'
        style.backgroundRepeat = 'no-repeat'
      }
      if (!style.background && !style.backgroundImage) {
        style.background = '#ffffff'
      }
      return style
    },
    combinedStyle() {
      const style = { ...this.pageStyle }
      style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`
      style.cursor = this.isDragging ? 'grabbing' : 'pointer'
      style.transition = this.isDragging ? 'none' : 'transform 0.3s ease-out'
      return style
    }
  },
  created() {
    this.updateSrcFromRoute()
  },
  mounted() {
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.endDrag)
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.endDrag)
  },
  watch: {
    $route: 'updateSrcFromRoute'
  },

  methods: {
    updateSrcFromRoute() {
      const q = (this.$route && this.$route.query) || {}
      const src = q.url || q.src || ''
      const bg = q.bg || q.color || ''
      const bgImg = q.bgImg || q.bgImage || q.bgUrl || ''
      const bgOnly = q.bgOnly || q.onlyBg || ''
      this.srcFromQuery = src ? decodeURIComponent(src) : ''
      this.bgFromQuery = bg ? decodeURIComponent(bg) : ''
      this.bgImgFromQuery = bgImg ? decodeURIComponent(bgImg) : ''
      if (typeof bgOnly === 'string' && bgOnly.length) {
        this.showImage = !['1', 'true', 'yes'].includes(bgOnly.toLowerCase())
      }
      // 重置缩放和位置
      this.scale = 1
      this.translateX = 0
      this.translateY = 0
    },
    resolveBgColor(input) {
      if (!input) return ''
      const val = String(input).trim()
      // rgb/rgba/hsl/hsla
      if (/^(rgb|hsl)a?\(/i.test(val)) return val
      // CSS color keywords
      if (/^[a-zA-Z]+$/.test(val)) return val
      // hex with/without #
      const hex = val.startsWith('#') ? val : `#${val}`
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(hex)) return hex
      return ''
    },
    // 点击切换缩放
    toggleZoom(event) {
      // 如果发生了拖拽，不触发点击缩放
      if (this.hasDragged) {
        return
      }

      if (this.isZoomed) {
        // 如果已放大，则恢复原始大小
        this.resetZoom()
      } else {
        // 如果是原始大小，则放大到2.5倍
        this.scale = 2.5
        this.isZoomed = true
      }
    },
    // 重置缩放
    resetZoom() {
      this.scale = 1
      this.translateX = 0
      this.translateY = 0
      this.isZoomed = false
    },
    // 开始拖拽
    startDrag(event) {
      this.dragStartTime = Date.now()
      this.hasDragged = false
      this.isDragging = true
      this.startX = event.clientX - this.translateX
      this.startY = event.clientY - this.translateY
    },
    // 拖拽中
    onDrag(event) {
      if (!this.isDragging) return

      const deltaX = Math.abs(event.clientX - this.startX - this.translateX)
      const deltaY = Math.abs(event.clientY - this.startY - this.translateY)

      // 如果移动距离超过5像素，认为发生了拖拽
      if (deltaX > 5 || deltaY > 5) {
        this.hasDragged = true
      }

      this.translateX = event.clientX - this.startX
      this.translateY = event.clientY - this.startY
    },
    // 结束拖拽
    endDrag() {
      this.isDragging = false
      // 延迟重置hasDragged，确保点击事件能正确判断
      setTimeout(() => {
        this.hasDragged = false
      }, 100)
    }
  }
}
</script>

<style scoped lang="scss">
.img-show-wrapper {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-show-page {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(http://192.168.31.183:8080/img/img1.967cbd65.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0;
  flex-direction: column;
  transform-origin: center center;
  user-select: none;
}

.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.image {
  display: block;
  height: auto;
  max-height: 90vh;
  max-width: 90vw;
  object-fit: contain;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  user-select: none;
  margin: auto;
}

.layout {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  //background-color: #e5eeff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  width: 100%;
  //height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  background: #ffffff;
  border: 1px dashed #e5e5e5;
  border-radius: 8px;
}

::v-deep .layout {
  color: rgb(108, 249, 103) !important;
}
</style>
